export const APIS = {
  Auth: "/common/auth/admin-login",
  LogOut: "/common/auth/admin-logout",
  PasswordFind: "/admin/user-management/check-current-password",
  PasswordUpdate: "/admin/user-management/change-password",
  UserUpdate: "/admin/user-management/update-profile",

  Dashboard: "/admin/dashboard",
  Masters: {
    Method_of_testing: "/admin/sample-management/method-of-testing",
    Customer_type: "/admin/customer-management/customer-type",
    PrefferedCommunicationMode:
      "/admin/customer-management/preferred-communication-modes",
    Parameters: "/admin/customer-management/parameter",
    Material_Tested:
      "/admin/quality-management-system/structure-requirement/material-tested",
    Test_Method:
      "/admin/quality-management-system/structure-requirement/test-method",
    Component:
      "/admin/quality-management-system/structure-requirement/component",
    Designation:
      "/admin/quality-management-system/resource-requirement/designation",

      TrainingType:
      "/admin/quality-management-system/resource-requirement/type-of-training",
      TrainingField:
      "/admin/quality-management-system/resource-requirement/training-field",
    Qualification:
      "/admin/quality-management-system/resource-requirement/qualification",
    Specialization:
      "/admin/quality-management-system/resource-requirement/specialization",
    Relevant_Training:
      "/admin/quality-management-system/resource-requirement/relevant-training",
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    City: "/admin/masters/city",
    Pincode: "/admin/masters/pincode",
    Room_Type:
      "/admin/quality-management-system/resource-requirement/room-type",
    Service_Used:
      "/admin/quality-management-system/resource-requirement/service-used",
    Test_Type: "/admin/masters/test-type",
    Type_Of_Verification: "/admin/masters/type-of-verification",
    Tested_By: "/admin/masters/tested-by",
    Nature_Of_Complaint: "/admin/masters/nature-of-complaint",
    Department: "/admin/masters/department",
    PaymentMethod: "/admin/masters/payment-method",
    MaintenanceStatus: "/admin/masters/maintenance-status",
  },

  Commons: {
    AllCity: "/common/masters/all-city",
    AllGender: "/common/masters/all-gender",
    AllPermmission: "/common/masters/all-permissions",
    AllCustomerType: "/common/masters/all-customer-type",
    AllPrefferedCommunicationMode:
      "/common/masters/all-preffered-communication",

    AllCustomer: "/common/masters/all-customer",
    AllChemist: "/common/masters/all-chemist",
    AllCalibratedBy: "/common/masters/all-calibrated-by",
    AllSampReceiver: "/common/masters/all-sample-receiver",
    AllParameter: "/common/masters/all-parameter",
    AllCategory: "/common/masters/all-category",
    AllMethodOfTesting: "/common/masters/all-method-of-testing",
    AllMaterialTested: "/common/masters/all-material-tested",
    AllComponent: "/common/masters/all-component",
    AllTestMethod: "/common/masters/all-test-method",
    AllPriority: "/common/masters/all-priority",
    AllSampRecievedBy: "/common/masters/all-samp-received-by",
    AllSampStatus: "/common/masters/all-samp-status",
    AllInstmentName: "/common/masters/all-instrument-name",
    AllModelNo: "/common/masters/all-model-no",
    AllSerialNo: "/common/masters/all-serial-no",
    AllCalibrationStatus: "/common/masters/all-calibration-status",
    Serial_Counter: "/common/masters/next-serial-no",

    AllRoles: "/common/masters/all-roles",

    AllTeam: "/common/masters/all-team",
    AllPaymentMethod: "/common/masters/all-payment-method",
    AllInstrumentMaintance: "/common/masters/all-instrument-maintence",

    AllTrainingField: "/common/masters/all-training-field",
    AllTrainingStatus: "/common/masters/all-training-status",
    AllCustomerStatus: "/common/masters/all-customer-status",
    AllTrainingType: "/common/masters/all-training-type",

     allPermissionDropdown: "/common/masters/all-permission-dropdown",

    AllPaymentStatus: "/common/masters/all-payment-status",
    AllProduct: "/common/masters/all-product",

    AllPropertyType: "/common/masters/all-property-type",
    AllPropertyStatus: "/common/masters/all-property-status",
    AllProperty: "/common/masters/all-property",
    AllRoom: "/common/masters/all-rooms",

    BuySubscription: "/common/buy-subscription",
    AllSubscriptionHistory: "/common/masters/all-subscription-history",
    paymentHistory: "/common/payment-history",
    allDesignation: "/common/masters/all-designation",
    allQualification: "/common/masters/all-qualification",
    allSpecialization: "/common/masters/all-specification",
    allRelevant_Training: "/common/masters/all-relevant-training",
    AllCountry: "/common/masters/all-country",
    AllState: "/common/masters/all-state",
    allInstrumentManagement: "/common/masters/all-instrument-management",
    allRoomType: "/common/masters/all-room-type",
    allPerformance: "/common/masters/all-performance",
    allServiceUsed: "/common/masters/all-servicd-used",
    allNatureComplaints: "/common/masters/all-nature-of-complaints",
    allCustomerDetail: "/common/masters/all-customer-details",
    allTestType: "/common/masters/all-test-type",
    allVerificationType: "/common/masters/all-verification-type",
    allValidityType: "/common/masters/all-validity-type",
    allTestedBy: "/common/masters/all-tested-by",
    allSampleManagement: "/common/masters/all-sample-management",
    allComplaintStatus: "/common/masters/all-complaint-status",
    allDepartment: "/common/masters/all-department",
    allNon_Confirming_Work_Status:
      "/common/masters/all-non-confirming-work-status",
    allManagement_System_Requirement_Status:
      "/common/masters/all-management-system-requirement-status",
    allExternal_Audit_Status: "/common/masters/all-external",
    allUsers: "/common/masters/all-users",
  },

  UserManagement: {
    Roles: "/admin/roles-permission/role",
    Owner: "/admin/user-management/user",
  },

  PropertyManage: {
    Property: "/admin/property-management",
    PropertyStatus: "/admin/property-management/property-status",
    room: "/admin/property-management/room",
    tenant: "/admin/tenant-management",
  },
  CustomerManagement: {
    GetAllCustomer: "/admin/customer-management/customer-management",
    PostCutomerDetails:
      "/admin/customer-management/customer-management/customerDetails",
    PostOrganizationDetails:
      "/admin/customer-management/customer-management/organizationDetails",
    UpdateDetails:
      "/admin/customer-management/customer-management/update-customer-and-organization-detail",
    GetSampleById: "/admin/customer-management/customer-management/get-samples",

    SampleGenerate: "/admin/certificate-generation/download",

    
  },

  SampleManagement: {
    SampleManagement: "/admin/sample-management/sample-management",
    SampleManagementCounter: "/admin/sample-management/sample-management/count",
  },

  InstrumentManagement: {
    InstrumentManagement: "/admin/instrument-management/instrument-management",
    InstrumentManagementCounter:
      "/admin/instrument-management/instrument-management/count",
  },

  Consumable_item:
    "/admin/instrument-management/consumable-item-management/consumable-item-management",

  GetProfile: "/admin/user-management/get-profile",
  getAppSetup: "/admin/user-management/app-setup",

  Imperiality:
    "/admin/quality-management-system/general-requirement/imperiality",

  Confidentiality:
    "/admin/quality-management-system/general-requirement/confidentiality",

  Legal_Entity:
    "/admin/quality-management-system/structure-requirement/legal-entity",

  Quality_Policy:
    "/admin/quality-management-system/structure-requirement/quality-policy",
  Objective: "/admin/quality-management-system/structure-requirement/objective",

  Scope_of_Laboratory:
    "/admin/quality-management-system/structure-requirement/scope-of-laboratory",

  Management_Data:
    "/admin/quality-management-system/structure-requirement/management-data",

  Metrological_Traceability:
    "/admin/quality-management-system/resource-requirement/metrological-traceability",

  Intermediate_Equipment:
    "/admin/quality-management-system/resource-requirement/intermediate-check",

  Instrument_Equipment:
    "/admin/quality-management-system/resource-requirement/instrument-check",

  Personnel_Detail:
    "/admin/quality-management-system/resource-requirement/personnel-details",

    Training_Detail:
    "/admin/quality-management-system/resource-requirement/training-details",

  Environmental_Condition:
    "/admin/quality-management-system/resource-requirement/environment-condition",

  Externally_Provided:
    "/admin/quality-management-system/resource-requirement/vendor-details",

  ProcessRequirement: {
    Calibratio_Item:
      "/admin/quality-management-system/process-requirement/calibration-item",
    Complaint: "/admin/quality-management-system/process-requirement/complaint",

    Tender: "/admin/quality-management-system/process-requirement/tender",
    Selection_Type_Record:
      "/admin/quality-management-system/process-requirement/selection",
    Quality_Control_Plan:
      "/admin/quality-management-system/process-requirement/quality-control-plan",
    Validity_Type_Record:
      "/admin/quality-management-system/process-requirement/validity",
    Non_Confirming_Work:
      "/admin/quality-management-system/process-requirement/non-confirming-work",
    Accuracy: "/admin/quality-management-system/process-requirement/accuracy",
    Measurement_Type_Data:
      "/admin/quality-management-system/process-requirement/measurement-uncertainity",
  },

  ManagementSystem: {
    Management_System_Record:
      "/admin/quality-management-system/management-system",
  },

  CerficateManagement: {
    CerficateGenerate: "/admin/certificate-generation",
  },

  ExternalAudit: {
    External_Audit: "/admin/audit-and-traceability-logs/external-audit",
  },

  ReportGeneration: {
    ReportGeneration: "/admin/report-generation",
  },

  Dashboard: "/admin/dashboard",
};
